module.exports = __webpack_public_path__ + "static/assets/ba72cfccb626401a023311eb39edacb8.svg";